import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_QuestionsComponent = _resolveComponent("QuestionsComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, { pageTitle: "Preguntas" }),
    _createVNode(_component_QuestionsComponent, {
      play: _ctx.play,
      getPlayConfig: _ctx.getPlayConfig,
      "onUpdate:playItems": _cache[0] || (_cache[0] = updated => _ctx.play.items = updated)
    }, null, 8 /* PROPS */, ["play", "getPlayConfig"])
  ]))
}